import { defineMessages } from 'react-intl-next';

export const messages: {
	campaignLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	campaignLabel: {
		id: 'search-graph-campaign.campaign-label',
		defaultMessage: 'Campaign',
		description: 'Campaign noun type label for Salesforce Campaign search results',
	},
});
